module.exports = __webpack_public_path__ + "img/invest-page-surface.185b2fb8.svg";